import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProducts } from "../../constants";
import {
  GenerateProductVariantSKUAndShortIdRequestBody,
  GenerateProductVariantSKUAndShortIdResponse
} from "./generateProductVariantSKUAndShortId.types";

export const requestGenerateProductVariantSKUAndShortId = async ({
  categoryId
}: GenerateProductVariantSKUAndShortIdRequestBody): Promise<GenerateProductVariantSKUAndShortIdResponse> => {
  return await instance.post(
    buildUrl(ApiRoutesProducts.ProductVariantSKUAndShortId, categoryId)
  );
};
